import React from "react";

// Small unread-count pill shown next to a sidebar/nav icon. Renders nothing
// when the count is zero — this is what makes a badge "disappear" once its
// section has been opened and its notifications marked read.
export default function NavBadge({ count }) {
  if (!count) return null;
  return (
    <span className="ml-auto flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white">
      {count > 99 ? "99+" : count}
    </span>
  );
}
